import * as React from 'react'
import { Box } from '@mui/material'
import pitchImg from 'assets/images/pitch.png'

interface Props {
  children: React.ReactNode
  overlay?: React.ReactNode
  borderRadius?: number | string
}

/** Square pitch surface — GK row sits at the top of the card. */
const TemplatePitchSurface: React.FC<Props> = ({ children, overlay, borderRadius = 8 }) => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      aspectRatio: '1 / 1',
      borderRadius,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      <Box
        component="img"
        src={pitchImg}
        alt=""
        sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </Box>
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(180deg, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.22) 100%)',
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
    {overlay}
    <Box sx={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {children}
    </Box>
  </Box>
)

export default TemplatePitchSurface
